import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {useStyles} from '@wix/tpa-settings/react'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../../../../../stylesParams'
import {useWidgetActions, useWidgetState} from '../../../../../../hooks/state-provider'
import {
  getDayMonthText,
  getEventsForDay,
  getSelectedDate,
  getSelectedEventId,
} from '../../../../../../selectors/calendar-layout'
import {getCompId} from '../../../../../../selectors/component'
import {getEventById} from '../../../../../../selectors/events'
import {POPUP_LAYOUT_BREAKPOINT} from '../../../../../../utils/calendar'
import {PopupHeader} from '../header'
import s from './monthly-calendar-event-details.scss'
import {SideBySideEventDetailsLayout} from './side-by-side-layout'
import {VerticalEventDetailsLayout} from './vertical-layout'

export const MonthlyCalendarEventDetails = () => {
  const {isMobile} = useEnvironment()
  const {get} = useStyles()
  const {closeMonthlyCalendarPopup: closeMonthlyCalendarPopupAction, closeMonthlyCalendarEvent} = useWidgetActions()
  const {experiments} = useExperiments()

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)
  const selectedDate = useWidgetState(getSelectedDate)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const dateText = useWidgetState(state => getDayMonthText(state, selectedDate))
  const events = useWidgetState(state => getEventsForDay(state, selectedDate))
  const event = useWidgetState(state => getEventById(state, selectedEventId))
  const componentId = useWidgetState(getCompId)

  const goBackToEventList = () => {
    closeMonthlyCalendarEvent()
    calendarRevampEnabled &&
      setTimeout(
        () =>
          focusElement({
            selector: hookToAttributeSelector(DH.calendarEventListItem(event.id), {componentId}),
            canFocus: true,
            preventScroll: true,
          }),
        50,
      )
  }

  const closeMonthlyCalendarPopup = () => {
    closeMonthlyCalendarPopupAction()
    calendarRevampEnabled &&
      focusElement({
        selector: hookToAttributeSelector(DH.calendarCell(selectedDate), {componentId}),
        canFocus: true,
        preventScroll: true,
      })
  }

  return (
    <div className={classNames(s.container)} data-hook="calendar-event-details">
      <PopupHeader
        eventDetails
        text={dateText}
        onClose={() => closeMonthlyCalendarPopup()}
        onBack={events.length > 1 ? goBackToEventList : undefined}
      />
      {calendarRevampEnabled && !isMobile && get(stylesParams.calendarHeight) <= POPUP_LAYOUT_BREAKPOINT ? (
        <SideBySideEventDetailsLayout />
      ) : (
        <VerticalEventDetailsLayout />
      )}
    </div>
  )
}
